import React from "react";

export default ({ children }) => (
  <section className="container">{children}</section>
);
